import { render, staticRenderFns } from "./MemberGroupForm.vue?vue&type=template&id=262913f6"
import script from "./MemberGroupForm.vue?vue&type=script&lang=js"
export * from "./MemberGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports